import React from 'react'

import awards from '../../mocks/awards'
import * as S from './styled'

const Awards = () => (
  <S.AwardsWrapper>
    <S.AwardsList>
      {awards.map((award, i) => (
        <S.AwardsItem
          key={i}
          data-sal="slide-right"
          data-sal-delay={i * 100 + 400}
          data-sal-easing="ease"
          data-sal-duration="600"
        >
          <S.AwardsText>{award}</S.AwardsText>
        </S.AwardsItem>
      ))}
    </S.AwardsList>
  </S.AwardsWrapper>
)

export default Awards
